<div class="step-unit-types" *transloco="let t" data-testid="wizard-step-unit-types">
  <p-card>
    <ng-template #header>
      <div class="card-header">
        <div class="header-left">
          <i class="pi pi-th-large header-icon"></i>
          <div class="header-text">
            <h2 class="header-title">{{ t('objects.wizard.unitTypes.title') }}</h2>
            @if (totalImages() > 0) {
              <span class="header-image-count" [class.limit-reached]="isGlobalImageLimitReached()">
                <i class="pi" [class.pi-images]="!isGlobalImageLimitReached()" [class.pi-exclamation-triangle]="isGlobalImageLimitReached()"></i>
                {{ t('objects.wizard.gallery.globalImageCount', { current: totalImages(), max: limits.GLOBAL_MAX_IMAGES }) }}
              </span>
            }
          </div>
        </div>
        @if (canAddMore() && unitTypes().length > 0) {
          <p-button
            data-testid="wizard-units-add-btn"
            [label]="t('objects.wizard.unitTypes.addType')"
            icon="pi pi-plus"
            [outlined]="true"
            [disabled]="isViewMode()"
            (onClick)="addUnitType()"
          />
        }
      </div>
    </ng-template>

    <div class="card-content">
      <app-wizard-step-hint
        icon="pi pi-th-large"
        [text]="t('positioning.wizard.unitTypes')" />

      <div class="units-list">
        @for (unit of unitTypes(); track trackByUnitId($index, unit); let i = $index) {
          <app-unit-type-card
            [attr.data-testid]="'wizard-unit-card-' + i"
            [unitType]="unit"
            [index]="i"
            [disabled]="isViewMode()"
            [canRemove]="canRemove()"
            [validationErrors]="getUnitErrors(unit.id)"
            [startExpanded]="lastAddedId() === unit.id"
            (unitChange)="onUnitChange($event)"
            (remove)="onRemoveUnit($event)"
            (uploadStateChange)="onCardUploadState(unit.id, $event)"
          />
        } @empty {
          <div class="empty-state" data-testid="wizard-units-empty">
            <i class="pi pi-home"></i>
            <h3>{{ t('objects.wizard.unitTypes.emptyInfoTitle') }}</h3>
            <p class="empty-explanation">{{ t('objects.wizard.unitTypes.emptyInfoDescription') }}</p>
            <div class="empty-examples">
              <div class="example-item">
                <i class="pi pi-building"></i>
                <span>{{ t('objects.wizard.unitTypes.exampleHotel') }}</span>
              </div>
              <div class="example-item">
                <i class="pi pi-sun"></i>
                <span>{{ t('objects.wizard.unitTypes.exampleCottage') }}</span>
              </div>
              <div class="example-item">
                <i class="pi pi-th-large"></i>
                <span>{{ t('objects.wizard.unitTypes.exampleApartment') }}</span>
              </div>
            </div>
            <p class="empty-hint">{{ t('objects.wizard.unitTypes.emptyHint') }}</p>
            <p-button
              data-testid="wizard-units-add-first-btn"
              [label]="t('objects.wizard.unitTypes.addFirstType')"
              icon="pi pi-plus"
              (onClick)="addUnitType()"
            />
          </div>
        }

        @if (canAddMore() && unitTypes().length > 0 && !isViewMode()) {
          <button
            class="add-type-placeholder"
            data-testid="wizard-units-add-bottom-btn"
            (click)="addUnitType()"
          >
            <i class="pi pi-plus"></i>
            <span>{{ t('objects.wizard.unitTypes.addNextType') }}</span>
          </button>
        }
      </div>

      @if (unitTypes().length >= limits.MAX_UNIT_TYPES) {
        <p-message severity="info" [text]="t('objects.wizard.unitTypes.maxReached')" />
      }
    </div>

    @if (!isViewMode()) {
      <ng-template #footer>
        <div class="card-footer">
          <p-button
            data-testid="wizard-units-back-btn"
            [label]="t('objects.wizard.footer.back')"
            severity="secondary"
            [text]="true"
            (onClick)="onPrevious()"
          />
          <p-button
            data-testid="wizard-units-next-btn"
            [label]="t('objects.wizard.footer.next')"
            icon="pi pi-chevron-right"
            iconPos="right"
            [disabled]="!canGoNext()"
            (onClick)="onNext()"
          />
        </div>
      </ng-template>
    }
  </p-card>
</div>
